<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{'invoices.edit.serviceData.other.itemsAvailable' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="padding: 10px">
    <div style="display: flex; flex-direction: row;align-items: baseline">
        <h5 class="roboSubTitle">{{'general.search' | translate}}</h5>
        <div class="input-group" style="margin-left: 10px; flex: 1;">
            <input type="text"  [ngStyle]="{'border-radius': '10px 0px 0px 10px'}" [(ngModel)]="titleSearch" (keyup)="search($event)" class="form-control" [placeholder]="'placeholder.searchByName' | translate" aria-label="Cerca per nome" aria-describedby="basic-addon1">
            <span class="input-group-text" id="basic-addon1" (click)="search(null)"><i class="bi bi-search"></i> <!--{{ 'general.search' | translate }}--> </span>
        </div>
    </div>
    <div style="margin: 0;margin-top: 10px;overflow-x: auto;">
        <table class="table" *ngIf="listArticoli && listArticoli.length > 0">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">Descrizione</th>
                    <th scope="col">U.M.</th>
                    <th scope="col">Prezzo Unitario</th>
                    <th scope="col">Aliquota IVA</th>
                    <th scope="col">Natura es. IVA</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let doc of listArticoli" (click)="doc.selected = true; selectOne(doc)" style="cursor: pointer;">
                    <td>
                        <input type="checkbox" class="form-check-input" style="margin-left: 0;" [(ngModel)]="doc.selected" (ngModelChange)="selectOne(doc)">
                    </td>
                    <td>
                        <h5>{{doc.descrizione}}</h5>
                    </td>
                    <td>
                        <h5>{{doc.unitadimisura}}</h5>
                    </td>
                    <td>
                        <h5>{{doc.prezzounitario}}</h5>
                    </td>
                    <td>
                        <h5>{{doc.aliquotaiva}}</h5>
                    </td>
                    <td>
                        <h5>{{doc.natura}}</h5>
                    </td>
                </tr>
            </tbody>    
        </table>
        <ng-container *ngIf="listArticoli && listArticoli.length == 0 && !first && !loading">
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
        </ng-container>
        <app-loading *ngIf="loading"></app-loading>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()">{{ 'general.save' | translate }}</button>
</div>